// extracted by mini-css-extract-plugin
export var checkbox_container = "contactForm-module--checkbox_container--r+Mmu";
export var contactForm = "contactForm-module--contactForm--Zg+1j";
export var form = "contactForm-module--form--8-3ZZ";
export var formBottom = "contactForm-module--formBottom--BYIme";
export var formContain = "contactForm-module--formContain--hKcyP";
export var formTop = "contactForm-module--formTop--7P-3b";
export var formTopInputs = "contactForm-module--formTopInputs--nG8jb";
export var formTopTitles = "contactForm-module--formTopTitles--Ajn69";
export var left = "contactForm-module--left--XQj7h";
export var leftBottom = "contactForm-module--leftBottom--qiqD5";
export var leftTop = "contactForm-module--leftTop--y+8Kv";
export var right = "contactForm-module--right--Yw-6h";
export var separator = "contactForm-module--separator--1cAKl";
export var socialMediaFix = "contactForm-module--socialMediaFix--oXCSG";
export var socialMediaNormal = "contactForm-module--socialMediaNormal--lO+7v";